<template>
	<div class="search-form-wrap">
		<v-btn fab dark small class="close-btn">
			<v-icon dark>close</v-icon>
		</v-btn>
		<div class="d-flex align-center justify-center centered">
            <form v-on:submit.prevent="onSubmit">
				<v-text-field 
                    ref="mobilekeywords"
					dark
					v-model="search"
					prepend-icon="search"
					placeholder="What are you looking for.."
					color="white"
				>
				</v-text-field>
			</form>
		</div>
	</div>
</template>

<script>

export default {
  data() {
    return {
      search: ""
    };
  },
  mounted() {
    const mobSearchBtn = document.querySelector('.mobile-search-btn');
    mobSearchBtn.onclick = (event) => {
        this.$refs.mobilekeywords.focus()

        event.stopPropagation();
        document.querySelector(".search-form-wrap").classList.add('search-slide');
    };
    document.querySelector(".close-btn").onclick = function(event) {
        event.stopPropagation();
        document.querySelector(".search-form-wrap").classList.remove('search-slide');
    };
    // document.querySelector(".search-form-wrap").onclick =  function(event) {
        //   event.stopPropagation();
        //   document.querySelector(".search-form-wrap").classList.remove('search-slide');
    // };
  },
  methods: {
    onSubmit() {
        if(this.search){
            this.$router.push("/admin/search/" + this.search);

            setTimeout(() => {
                document.querySelector(".search-form-wrap").classList.remove('search-slide');
            }, 500);
        }
    }
  }
};
</script>

